var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var toCurrency = function (value, currency) {
    if (currency === void 0) { currency = 'USD'; }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    });
    return formatter.format(value);
};
export var toNumberDisplayValue = function (value, options) {
    var _a = options !== null && options !== void 0 ? options : {}, digits = _a.digits, compact = _a.compact;
    var formatter = new Intl.NumberFormat('en-US', __assign({}, (typeof digits === 'number'
        ? {
            notation: compact ? 'compact' : 'standard',
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        }
        : { notation: compact ? 'compact' : 'standard' })));
    return formatter.format(value);
};
export var decimalToPercentage = function (value, digits) {
    if (digits === void 0) { digits = 2; }
    return Number((Math.round((value !== null && value !== void 0 ? value : 0) * 100 * 100) / 100).toFixed(digits));
};
//# sourceMappingURL=number.js.map